<div class="modal-container">
  <button
    id="modalVerificarCodigoDobleFactor"
    #modalVerificarCodigoDobleFactor
    data-bs-toggle="modal"
    data-bs-target="#modalVerificarDobleFactor"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalVerificarDobleFactor"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header modal-header-govco modal-header-alerts-govco">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body modal-body-govco">
          <app-form
            [title]="'verificacion-doble-factor.titulo' | translate"
            [fields]="fieldsVerificarCodigo"
            [sumbitButtonText]="'Verificar código'"
            (submitAction)="
              onSubmitVerificarCodigoDobleFactor($event)
            "></app-form>
        </div>
      </div>
    </div>
  </div>
</div>
